import { FC } from "react";
import {
    StaffFeaturesModal,
    StaffRolesModal,
} from "../../../../features/staffAccessManagement";
import { TStaffAccessManagement } from "../../model/useStaffAccessManagement";

interface IStaffAccessModalsProps {
    access: TStaffAccessManagement;
}

export const StaffAccessModals: FC<IStaffAccessModalsProps> = ({
    access,
}) => {
    const {
        rolesModalOpen,
        setRolesModalOpen,
        roleOptions,
        roleIdsToAssign,
        setRoleIdsToAssign,
        onAssignRoles,
        featuresModalOpen,
        setFeaturesModalOpen,
        featureOptions,
        featureSearchItems,
        setFeatureSearchItems,
        featureIdsToGrant,
        setFeatureIdsToGrant,
        isAvailableFeaturesLoading,
        onGrantFeatures,
    } = access

    return <>
        <StaffRolesModal
            open={rolesModalOpen}
            setOpen={setRolesModalOpen}
            roles={roleOptions}
            selectedIds={roleIdsToAssign}
            onToggle={(roleId, selected) => setRoleIdsToAssign(prev => selected ? [...prev, roleId] : prev.filter(id => id !== roleId))}
            onSave={onAssignRoles}
        />
        <StaffFeaturesModal
            open={featuresModalOpen}
            setOpen={setFeaturesModalOpen}
            options={featureOptions}
            searchItems={featureSearchItems}
            setSearchItems={setFeatureSearchItems}
            selectedIds={featureIdsToGrant}
            isLoading={isAvailableFeaturesLoading}
            isGranted={() => false}
            onToggle={(featureId, selected) => setFeatureIdsToGrant(prev => selected ? [...prev, featureId] : prev.filter(id => id !== featureId))}
            onSave={onGrantFeatures}
        />
    </>
}
